import React, { useRef } from 'react';
import { useAudio } from '../../../../../../contexts';
import { Box } from '../../../../../Box';
import { useThumbDragging } from '../../hooks/useThumbDragging';
import * as S from './styled';
import { getPercentage } from './utils';
export function AudioThumb(_ref) {
  var currentTime = _ref.currentTime,
      children = _ref.children,
      height = _ref.height,
      color = _ref.color;
  var containerRef = useRef(null);

  var _useAudio = useAudio(),
      duration = _useAudio.duration;

  var _useThumbDragging = useThumbDragging(containerRef),
      handleMouseDown = _useThumbDragging.handleMouseDown;

  var thumbPosition = getPercentage(currentTime, duration);
  return /*#__PURE__*/React.createElement(Box, {
    position: "relative",
    cursor: "pointer",
    ref: containerRef
  }, /*#__PURE__*/React.createElement(S.Thumb, {
    value: thumbPosition,
    onMouseDown: handleMouseDown,
    height: height,
    color: duration ? color : 'grey.base'
  }), children);
}